query ChatBans($page: Int, $rowsPerPage: Int) {
  chatBans(page: $page, rowsPerPage: $rowsPerPage) {
    count
    nodes {
      id
      type
      expiredAt
      createdAt
      userId
      user {
        id
        email
        displayName
      }
    }
  }
}
